
import { TDataGridSortFilter } from "components/data-grid/hooks/useDataGridFilterState";
import { atomFamily } from "recoil";

export const DataGridFilterState = atomFamily<TDataGridSortFilter, string>({
    key: 'state.DataGridFilterState',
    default: {},
});
